module.exports = __webpack_public_path__ + "static/color-27b02c5f551d48505aa82173a8f73ca5.jpg";